import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface UpdateUserProfileInterface {
  firstName: string;
  lastName: string;
  email: string;
  address1: string;
  address2: string;
  address3: string;
  dob: string;
  bankDetails: {
    account_number: string;
    account_holder_name: string;
    bank_name: string;
    branch_name: string;
  };
}

export const useUpdateUserProfile = () => {
  const mutate = useMutation(
    ({
      firstName,
      lastName,
      email,
      address1,
      address2,
      address3,
      dob,
      bankDetails,
    }: UpdateUserProfileInterface) => {
      return postAPI('/creator-api/update_user_details', {
        first_name: firstName,
        last_name: lastName,
        email,
        address1,
        address2,
        address3,
        dob,
        bankDetails,
      });
    },
  );

  return mutate;
};

export default useUpdateUserProfile;
